import React, { PropTypes } from 'react';
import ManipButtons from '../ManipButtons';

const AnnexItem = ({ manip, onUpdated, onDeleted, disabled = false, _ }) => (
  <tr>
    <ManipButtons
      manip={manip}
      onUpdated={onUpdated}
      onDeleted={onDeleted}
      hideHistory={true}
      disabled={disabled}
    />
    <td>{manip.number}</td>
    <td>{manip.product_name}</td>
    <td>{manip.product_quantity}</td>
    <td>{manip.product_dilution}</td>
    <td>{manip.comp_product_name}</td>
    <td>{manip.comp_product_quantity}</td>
    <td>{manip.comp_product_dilution}</td>
  </tr>
);

AnnexItem.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default AnnexItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/AnnexItem.js